'use client';

import { Button } from '@common/components';
import SvgExpandWindow from '@common/icon/SvgExpandWindow';
import { useState } from 'react';

import { useLoginGuard } from '@/hooks/useLoginGuard';

import { MarketShareDrawer } from './MarketShareDrawer';

export const MarketShareButton = () => {
  const loginGuard = useLoginGuard();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        aria-label="공유하기"
        className="relative size-26 p-0"
        dimensions="H26"
        theme="primary-text"
        onClick={() => {
          if (!loginGuard()) {
            return;
          }

          setIsOpen(true);
        }}
      >
        <SvgExpandWindow className="size-24" />
      </Button>
      <MarketShareDrawer opened={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
